'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLoadedInServer = isLoadedInServer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.login = login;
exports.logout = logout;
exports.resetError = resetError;
exports.resetAuth = resetAuth;
exports.refreshLogout = refreshLogout;

var _constants = require('redux/constants');

function isLoadedInServer(globalState) {
    return globalState.auth && globalState.auth.loadedInServer;
}

function isLoaded(globalState) {
    return globalState.auth && globalState.auth.loaded;
}

function load() {
    return {
        types: [_constants.AuthConstants.AUTH_LOAD, _constants.AuthConstants.AUTH_LOAD_SUCCESS, _constants.AuthConstants.AUTH_LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getUserData();
        }
    };
}

function login(_ref) {
    var login = _ref.login,
        password = _ref.password,
        _ref$captcha = _ref.captcha,
        captcha = _ref$captcha === undefined ? null : _ref$captcha,
        _ref$callback = _ref.callback,
        callback = _ref$callback === undefined ? null : _ref$callback,
        _ref$shopId = _ref.shopId,
        shopId = _ref$shopId === undefined ? null : _ref$shopId;

    return {
        types: [_constants.AuthConstants.LOGIN, _constants.AuthConstants.LOGIN_SUCCESS, _constants.AuthConstants.LOGIN_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.userAuthentication(login, password, captcha, shopId).then(function (result) {
                if (callback) callback();
                return result;
            });
        }
    };
}

function logout() {
    return {
        types: [_constants.AuthConstants.LOGOUT, _constants.AuthConstants.LOGOUT_SUCCESS, _constants.AuthConstants.LOGOUT_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.userLogout();
        }
    };
}

function resetError() {
    return {
        type: _constants.AuthConstants.AUTH_RESET_ERROR
    };
}

function resetAuth() {
    return {
        type: _constants.AuthConstants.AUTH_RESET
    };
}

function refreshLogout() {
    return {
        type: _constants.AuthConstants.REFRESH_LOGOUT_SUCCESS
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/auth.js
// module id = 53
// module chunks = 0